import style from "./Sidebar.module.css";
import SidebarItem from "../sidebarItem/SidebarItem";
import { FaHome, FaUserGraduate } from "react-icons/fa";
import { SiGoogleclassroom } from "react-icons/si";
import { MdAssessment, MdContactSupport } from "react-icons/md";
import { IoIosNotifications } from "react-icons/io";
import { FaCalendarDays, FaUserClock } from "react-icons/fa6";
import { IoDocumentSharp } from "react-icons/io5";
import { PiCertificateFill } from "react-icons/pi";
import { useEffect, useRef, useState } from "react";
import { useIsMobile } from "../useIsMobile/UseIsMobile";
import MenuHamburguer from "../menuHamburguer/MenuHambueguer";
import clsx from "clsx";
import { List } from 'lucide-react';
import ValidarPermissao from '../../services/ValidarPermissao';
import FuncionalidadesNome from "../../constants/FuncionalidadesNome";

function Sidebar({ children, menuHamburguerAberto, setMenuHamburguerAberto }) {
  const isMobile = useIsMobile();
  const sidebarRef = useRef(null);
  const [mostrarAlca, setMostrarAlca] = useState(false);

  useEffect(() => {
    function handleClickOutside(event) {
      if (
        isMobile &&
        menuHamburguerAberto &&
        sidebarRef.current &&
        !sidebarRef.current.contains(event.target)
      ) {
        setMenuHamburguerAberto(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [menuHamburguerAberto, isMobile]);

  // ⏱️ Delay para exibir alça só depois da animação de fechamento
  useEffect(() => {
    let timeout;
    if (!menuHamburguerAberto) {
      timeout = setTimeout(() => setMostrarAlca(true), 200);
    } else {
      setMostrarAlca(false);
    }
    return () => clearTimeout(timeout);
  }, [menuHamburguerAberto]);

  const ExibirItemAlunos =
    ValidarPermissao.validar(FuncionalidadesNome.ExibirItemSidebarAlunos);

  const ExibirItemTurmas =
    ValidarPermissao.validar(FuncionalidadesNome.ExibirItemSidebarTurmas);

  const ExibirItemAvaliacoes =
    ValidarPermissao.validar(FuncionalidadesNome.ExibirItemSidebarAvaliacoes);

  const ExibirItemAvisos =
    ValidarPermissao.validar(FuncionalidadesNome.ExibirItemSidebarAvisos);

  const ExibirItemDocumentos =
    ValidarPermissao.validar(FuncionalidadesNome.ExibirItemSidebarDocumentos);

  const ExibirItemSuportes =
    ValidarPermissao.validar(FuncionalidadesNome.ExibirItemSidebarSuporte);

  const ExibirItemCalendario =
    ValidarPermissao.validar(FuncionalidadesNome.ExibirItemSidebarCalendario);

  const ExibirItemFrequencia =
    ValidarPermissao.validar(FuncionalidadesNome.ExibirItemSidebarFrequencia);

  const ExibirItemCertificado =
    ValidarPermissao.validar(FuncionalidadesNome.ExibirItemSidebarCertificados);


  return (
    <div className={style.container_total}>
      {isMobile && menuHamburguerAberto && (
        <div className={style.overlay}></div>
      )}

      {/* Alça lateral para reabrir a sidebar */}
      {mostrarAlca && (
        <div className={style.sidebar_tab} onClick={() => setMenuHamburguerAberto(true)}>
          <List size={20} strokeWidth={3} color="white" />
        </div>
      )}

      <div
        ref={sidebarRef}
        className={clsx(style.sidebar_conteudo, {
          [style.sidebar_hidden]: !menuHamburguerAberto,
        })}
      >
        <div className={style.menuHamburguerWrapper}>
          <MenuHamburguer
            menuHamburguerAberto={menuHamburguerAberto}
            setMenuHamburguerAberto={setMenuHamburguerAberto}
          />
        </div>

        <div className={style.sidebar_corpo}>
          <SidebarItem texto="Home" link="/" logo={<FaHome />} />
          {ExibirItemAlunos && <SidebarItem texto="Alunos" link="/alunos" logo={<FaUserGraduate />} />}
          {ExibirItemTurmas && <SidebarItem texto="Turmas" link="/turmas" logo={<SiGoogleclassroom />} />}
          {ExibirItemAvaliacoes && <SidebarItem texto="Avaliações" link="/avaliacoes" logo={<MdAssessment />} />}
          {ExibirItemAvisos && <SidebarItem texto="Avisos" link="/avisos" logo={<IoIosNotifications />} />}
          {ExibirItemDocumentos && <SidebarItem texto="Documentos" link="/Documentos" logo={<IoDocumentSharp />} />}
          {ExibirItemSuportes && <SidebarItem texto="Suportes" link="/suportes" logo={<MdContactSupport />} />}
          {ExibirItemCalendario && <SidebarItem texto="Calendário" link="/calendario" logo={<FaCalendarDays />} />}
          {ExibirItemCertificado && <SidebarItem texto="Certificados" link="/certificados" logo={<PiCertificateFill />} />}
          {ExibirItemFrequencia && <SidebarItem texto="Frequência" link="/frequencias" logo={<FaUserClock />} />}
        </div>
      </div>

      <div
        className={clsx(style.pagina_conteudo, {
          [style.closed]: !menuHamburguerAberto && !isMobile,
        })}
      >
        {children}
      </div>
    </div>
  );
}

export default Sidebar;
